import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "yet-another-react-lightbox/styles.css";
import { useSelector } from "react-redux";
import React, { useState } from "react";

import { RootState } from "../../../core/data/redux/store";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";


const CarDetail = () => {
  const { carDetail, systemSettings } = useSelector((state: RootState) => ({
    carDetail: state.vehicle.carDetail,
    systemSettings: state.auth.systemSettings,
  }));

  const [isExpandedNotes, setIsExpandedNotes] = useState(true);

  return (
    <>
      <div
        className="modal new-modal fade"
        id="car_details"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog modal-lg">
          <div className="modal-content py-0">
            <div
              className="col-12 text-end position-absolute border-0"
              style={{
                left: "2px",
                zIndex: 99,
              }}
            >
              <button className="btn close-btn fs-1" data-bs-dismiss="modal">
                {" "}
                ×
              </button>
            </div>

            <div className="modal-body">
              <section className="product-detail-head shadow-none rounded-0 px-0 py-2">
                <div className="container">
                  <div className="detail-page-head">
                    <div className="detail-headings">
                      <div className="star-rated">
                        <ul className="list-rating mt-2">
                          <li>
                            <div className="car-brand">
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-icon.svg"
                                  alt="img"
                                />
                              </span>
                              {carDetail?.make}
                            </div>
                          </li>
                          <li>
                            <span className="year bg-primary text-white">
                              {"$" + (carDetail?.price_per_day || 0) + " / Day"}
                            </span>
                          </li>
                        </ul>
                        <div className="camaro-info">
                          <h6 className="text-primary-dark fw-bold">
                            {carDetail?.vehicle_name}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="section product-details p-0">
                <div className="row">
                  <div className="col-12 p-0">
                    <div className="review-sec shadow-none rounded-0 py-0  mt-1">
                      <div className="review-header  pb-0">
                        <h6 className="mb-0">Car & Rental Details</h6>
                      </div>
                      <div className="description-list">
                        <p>
                          <span className="fw-bold text-primary-dark ">
                            {" "}
                            Price{" "}
                          </span>{" "}
                          ${carDetail?.price_per_day} per day
                        </p>
                        <p>
                          <span className="fw-bold text-primary-dark ">
                            {" "}
                            Pickup{" "}
                          </span>{" "}
                          <i className="bx bx-map" />{" "}
                          {systemSettings?.default_pickup_location}
                        </p>
                        <p className="mb-0 text-justify">
                          <span className="fw-bold text-primary-dark ">
                            {" "}
                            Details{" "}
                          </span>{" "}
                          -{" "}
                          <span>
                            {isExpandedNotes &&
                            carDetail?.description?.length > 500
                              ? carDetail?.description?.substring(0, 500)
                              : carDetail?.description}

                            {carDetail?.description?.length > 500 && (
                              <a
                                href="#!"
                                onClick={() =>
                                  setIsExpandedNotes(!isExpandedNotes)
                                }
                                className="text-nowrap ms-2"
                              >
                                {isExpandedNotes
                                  ? "Read More... "
                                  : "Read Less"}
                              </a>
                            )}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarDetail;
